module.exports = __webpack_public_path__ + "img/worried-face.c50cb152.png";